module.exports = "../images/hunting-rifle.jpg?v=c7ed785";